/* 
 *  Created by SGiri 03/12/2018
 */

export class ConfigConstants {

  public static SAVE_NEW_DASHBOARD_URL = '/dashboard/savenewdashboard'
  public static ST_DASHBOARDL_URL = '/dashboard/stdashboardlist';
  public static GET_ST_DASHBOARDL_DATA_URL = '/dashboard/getstdashboardrowdata/';
  public static SAVE_ST_DASHBOARDL_DATA_URL = '/dashboard/savestdashboardrowdata';
  public static SAVE_NEW_WIDGET_URL = '/dashboard/savenewwidget';

  public static SAVE_ST_DASHBOARDL_KPI_URL = '/dashboard/savestdashboardkpidata';
  public static SAVE_NEW_KPI_URL = '/dashboard/savenewkpi';
  public static GET_KPI_REPORTS_URL = '/dashboard/getkpireports/';

  public static BI_FOLDERS_URL = '/repoFolders/folderslist';
  public static GET_FOLDER_REPORTS_DATA_URL = '/repoFolders/getreportsinfolderdata/';
  public static SAVE_REPORT_DATA_URL = '/repoFolders/savereportrowdata';
  public static BI_SYNC_WITH_COGNOS_URL = '/repoFolders/syncWithCognos';
  public static BI_UPDATE_BI_URL = '/repoFolders/updatebi';
  public static GET_COMPANY_FOLDERS_URL = '/repoFolders/getCompanyFolders/';

  public static SEARCH_URL = "/search";

  public static EXPORT_FOR_RELEASE_URL = '/search/exportforrelease';

  public static GET_RELEASE_VERSIONS_URL = '/search/getreleaseversions/';

  public static GET_LOCATION_MAPPING_URL = '/dashboard/getlocationmapping/';

  public static SAVE_REPORT_LOCATION_MAPPING_URL = '/dashboard/savereportlocationmapping';

  public static SAVE_KPI_LOCATION_MAPPING_URL = '/dashboard/savekpilocationmapping';

  public static DATA_DICTIONARY_URL = '/dataDictionary/truncateAndReload';

}


// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/util/config.constant.ts